import React,{useContext} from 'react'

import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import Map from '../../mencontact/Map'
import { LanguageContext } from '../../../LanguageContext';

function ContactUS() {
    const { language, setLanguage } = useContext(LanguageContext);
    return (
        <>
            <Header />
            <Breadcrumb title="Home" titleHi="मुख्य पृष्ठ" subtitle="Contact US" subtitleHi="संपर्क करें" />
            <section id="services" className="services-area pt-120 pb-90 fix">
                {/*   */}
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title text-center mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
                                <h5>
                                    <i className="fal fa-graduation-cap" /> {language==='en'?'Contact Information':'संपर्क जानकारी'}
                                </h5>
                                <h2>{language==='en'?'Get In Touch':'संपर्क में रहें '}</h2>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <div className="services-box text-center">
                                <div className="services-icon">
                                    <img src="assets/img/bg/contact-icon01.png" alt="image" />
                                </div>
                                <div className="services-content2 text-left  c-lineheight2dot5 text-dark fs-5 text">

                                    <p><i className="fal fa-phone-alt me-2"></i>{language==='en'?'Administration':'प्रशासन'} : 0877-250-3507</p>
                                    <p><i className="fal fa-phone-alt me-2"></i>{language==='en'?'Establishment':'स्थापना'} : 0877-250-3503</p>
                                    <p><i className="fal fa-phone-alt me-2"></i>{language==='en'?'Academics':'शैक्षणिक'} : 0877-250-3530</p>
                                    <p><i className="fal fa-phone-alt me-2"></i>{language==='en'?'Admissions':'प्रवेश'} : 0877-250-3532</p>
                                    <p><i className="fal fa-phone-alt me-2"></i>{language==='en'?'Accounts':'लेखा'} : 0877-250-3545</p>
                                    <p><i className="fal fa-phone-alt me-2"></i>{language==='en'?'Library':'पुस्तकालय'} : 0877-250-3591</p>
                                    <p><i className="fal fa-phone-alt me-2"></i>{language==='en'?'Placement':'स्थानन'} : 0877-250-3672</p>
                                    <p><i className="fal fa-phone-alt me-2"></i>{language==='en'?'Recruitment':'भर्ती'} : 0877-250-3505</p>
                                    <p><i className="fal fa-phone-alt me-2"></i>{language==='en'?'Stores':'भंडारण'} : 0877-250-3571</p>
                                    <p><i className="fal fa-phone-alt me-2"></i>{language==='en'?'Hostel & Mess Establishment (HoME)':'छात्रावास एवं भोजन संबंधी स्थापना'} : 08772503156</p>
                                    <p className="mt-3"> {language==='en'?'Search Contacts':'संपर्क खोजें'} </p>
                                    <p> <Link className="c-link" to="https://iittp.ac.in/TD" target="_blank">{language==='en'?'Telephone Directory':'दूरभाष निर्देशिका'} </Link> </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6">
                            <div className="services-box text-center active">
                                <div className="services-icon">
                                    <i className="fas fa-alarm-clock"></i>
                                </div>
                                <div className="services-content2 fs-6  text-dark c-lineheight2dot5">
                                {language==='en'? (<>
                                    <b>Working Days and Timings</b>
                                    <p>    Institute working days: Monday to Friday</p>
                                    <p>Institute working hours:09:00am to 05:30pm </p>
                                </>) : (<>
                                    <b>कार्य दिवस और समय</b>
                                    <p>संस्थान के कार्य दिवस: सोमवार से शुक्रवार</p>
                                    <p>संस्थान का कार्य समय: प्रातः 09:00 बजे से सायं 05:30 बजे तक</p>
                                </>)}
                                </div>
                            </div>

                            <div className="services-box text-center mt-5">
                                <div className="services-icon">
                                    <img src="assets/img/bg/contact-icon03.png" alt="image" />
                                </div>
                                <div className="services-content2">
                                {language==='en'? (<>
                                    <p className='fs-4 fw-bold mb-3'>Address</p>
                                    <h6 className='lh-lg fs-5 '>
                                    <p>  Indian Institute of Technology Tirupati</p>
                                    <p>Yerpedu – Venkatagiri Road, Yerpedu Post,</p>
                                    <p>Tirupati District,</p>
                                    <p>Andhra Pradesh - 517619.</p>
                                    </h6>
                                </>) : (<>
                                    <p className='fs-4 fw-bold mb-3'>पता</p>
                                    <h6 className='lh-lg fs-5 '>
                                    <p>भारतीय प्रौद्योगिकी संस्थान तिरुपति</p>
                                    <p>एर्पेडु – वेंकटगिरी रोड, एर्पेडु पोस्ट,</p>
                                    <p>तिरुपति जिला,</p>
                                    <p>आंध्र प्रदेश - 517619.</p>
                                    </h6>
                                </>)}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='mt-5 mb-3'>
                        <h4 className='mt-5 mb-3'>{language==='en'?'Map':'मानचित्र'}</h4>
                        <Map value="500" />
                    </div>
                </div>

    
            </section>
        </>
    )
}

export default ContactUS